import React from 'react';
import clsx from 'clsx';
import { DivisionLeadDraft } from '@app-types/division';
import styles from './DivisionLeadsCell.module.css';

export interface DivisionLeadsCellProps {
  /** Rendered by `user_name` (server-formatted "Name (Status)" for assigned leads). */
  leads: DivisionLeadDraft[];
  className?: string;
  /** Text shown when no one is assigned (default: 'No leads assigned'). */
  emptyText?: string;
  /** data-test-id for the names/empty-text element. */
  namesTestId?: string;
}

/** Display-only; leads are edited in the Edit Division modal (ADO-1159). */
const DivisionLeadsCell: React.FC<DivisionLeadsCellProps> = ({
  leads,
  className,
  emptyText = 'No leads assigned',
  namesTestId
}) => {
  return (
    <div className={clsx(styles.leadsCell, className)}>
      <div className={styles.leadsContent}>
        {leads.length === 0 ? (
          <span className={styles.textMuted} data-test-id={namesTestId}>
            {emptyText}
          </span>
        ) : (
          <span
            className={styles.leadNames}
            title={leads.map((l) => l.user_name).join(', ')}
            data-test-id={namesTestId}
          >
            {leads.length === 1 ? leads[0].user_name : `${leads[0].user_name} +${leads.length - 1}`}
          </span>
        )}
      </div>
    </div>
  );
};

export default DivisionLeadsCell;
